import { Box, Typography, Button, Dialog, Drawer } from "@mui/material";

import TableData from "components/TableData";
import { Db } from "../../helper/db";
import useFetch from "hooks/useFetch";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Delete from "./delete";

const User = () => {
  const [data, load, cancel] = useFetch("get_user");
  const [dialOpen, setDialOpen] = useState(false);
  const [dialDelete, setDialDelete] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [currentId, setCurrentId] = useState(null);
  const navigate = useNavigate();

  const [dataDelete, loadDelete, cancelDelete] = useFetch("user/" + currentId);

  const addUser = async () => {
    await navigate("/set_user");
  };

  const handleDialogDelete = () => {
    setDialDelete(!dialDelete);
  };

  const edit = async (data) => {
    await navigate(`/set_user?ref=${data.id}`);
  };

  const deleteUser = async (data) => {
    await setCurrentId(data.id);
    await handleDialogDelete();
  };

  const confirmDelete = async () => {
    loadDelete({}, "delete", "json", true).then((rep) => {
      if (rep) {
        load();
        handleDialogDelete();
      }
    });
  };

  const columns = [
    { field: Db.user_id, hide: true },
    { field: Db.user_login, headerName: "Login", width: 200 },
    { field: Db.user_mail, headerName: "Email", width: 150 },
  ];

  const actColums = [
    {
      field: "action",
      headerName: "",
      width: 200,
      renderCell: (params) => (
        <>
          <Button color="primary" size="small" onClick={() => edit(params)}>
            Modifier
          </Button>
          <Button
            color="primary"
            size="small"
            onClick={() => deleteUser(params)}
          >
            Supprimer
          </Button>
        </>
      ),
    },
  ];

  useEffect(() => {
    load();

    return () => {
      cancel.cancel();
      cancelDelete.cancel();
    };
  }, []);

  return (
    <div>
      <Box p={2}>
        <Typography variant="h5" component="h1" fontWeight="bold">
          Utilisateur
        </Typography>
      </Box>

      <Box p={2}>
        <Typography variant="h5" component="h1" fontWeight="bold">
          <Button color="primary" size="small" onClick={() => addUser()}>
            Ajouter
          </Button>
        </Typography>
      </Box>

      <Dialog fullWidth={true} maxWidth={"sm"} open={dialDelete}>
        {dialDelete && (
          <Delete
            confirmDelete={confirmDelete}
            closeDialog={handleDialogDelete}
            loading={dataDelete.loading}
          />
        )}
      </Dialog>

      <Box p={2}>
        <TableData
          rows={data.data || []}
          columns={[...columns, ...actColums]}
          height="82vh"
          width="100%"
          loading={data.loading}
        />
      </Box>
    </div>
  );
};

export default User;
